var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgressCompletedIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.0001 21.9c5.4676 0 9.9-4.4324 9.9-9.9s-4.4324-9.9-9.9-9.9-9.9 4.4324-9.9 9.9 4.4324 9.9 9.9 9.9m6.3205-12.897q.2395-.2661.2395-.612 0-.3723-.266-.6117-.2395-.2395-.5853-.2395t-.6118.2395l-6.1075 6.6325L7.57 11.218q-.266-.2394-.6118-.2394t-.5852.2394q-.266.2394-.266.6118 0 .3458.2394.6118l4.0313 3.7791q.266.2395.6118.2394t.6118-.2394z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgressCompletedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progress-completed-icon.25bcd4c8c4443cff85a64d85f5f8ef16.svg";